/* Size guide (Ink v2): drives the size finder and highlights the matching row in each chart.
   Reads chart data from the server-rendered tables (data attributes on each row), so the tables stay the single source. */
(function () {
  'use strict';

  var MIN = 140;
  var MAX = 205;

  function ftin(cm) {
    var total = Math.round(cm / 2.54);
    return Math.floor(total / 12) + '′' + (total % 12) + '″';
  }

  function clamp(v) {
    return Math.max(MIN, Math.min(MAX, v));
  }

  // Builds a bike search URL pre-filtered by size and bike type. Matches the state format the search service validates.
  function shopUrl(route, chart, size) {
    var type = chart.conceptLabel.replace(/ bikes$/i, '');
    var state = {
      version: 1,
      originalQuery: size + ' ' + type,
      residual: '',
      constraints: [
        { key: 'size:' + size, kind: 'size', value: size, label: size },
        { key: 'concept:' + chart.concept, kind: 'concept', value: chart.concept, label: chart.conceptLabel }
      ],
      notices: []
    };
    var encoded = btoa(unescape(encodeURIComponent(JSON.stringify(state)))).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    return route + '?' + new URLSearchParams({ q: state.originalQuery, bike_state: encoded }).toString();
  }

  function init(root) {
    var finder = root.querySelector('.sz-finder');
    if (!finder) return;

    var els = {
      slider: finder.querySelector('[data-slider]'),
      readMain: finder.querySelector('[data-read-main]'),
      readAlt: finder.querySelector('[data-read-alt]'),
      endMin: finder.querySelector('[data-end-min]'),
      endMax: finder.querySelector('[data-end-max]'),
      resType: finder.querySelector('[data-res-type]'),
      resSize: finder.querySelector('[data-res-size]'),
      resSpecs: finder.querySelector('[data-res-specs]'),
      resCm: finder.querySelector('[data-res-cm]'),
      resFt: finder.querySelector('[data-res-ft]'),
      note: finder.querySelector('[data-res-note]'),
      noteTag: finder.querySelector('[data-res-note-tag]'),
      noteText: finder.querySelector('[data-res-note-text]'),
      cta: finder.querySelector('[data-res-cta]'),
      ctaSize: finder.querySelector('[data-res-cta-size]'),
      ctaType: finder.querySelector('[data-res-cta-type]')
    };
    var typeBtns = [].slice.call(finder.querySelectorAll('[data-type]'));
    var unitBtns = [].slice.call(finder.querySelectorAll('[data-unit]'));

    var charts = {};
    [].forEach.call(root.querySelectorAll('[data-chart-table]'), function (table) {
      var key = table.getAttribute('data-chart-table');
      if (charts[key]) return;
      var section = table.closest('[data-chart]');
      charts[key] = {
        table: table,
        concept: section ? section.getAttribute('data-concept') : '',
        conceptLabel: section ? section.getAttribute('data-concept-label') : '',
        rows: [].map.call(table.querySelectorAll('tbody tr'), function (tr) {
          return {
            el: tr,
            size: tr.getAttribute('data-size'),
            frame: tr.getAttribute('data-frame'),
            inch: tr.getAttribute('data-inch'),
            ft: tr.getAttribute('data-ft'),
            cm: tr.getAttribute('data-cm'),
            min: parseFloat(tr.getAttribute('data-min')),
            max: parseFloat(tr.getAttribute('data-max'))
          };
        })
      };
    });

    var state = {
      type: (typeBtns[0] && typeBtns[0].getAttribute('data-type')) || 'road',
      unit: 'ft',
      cm: clamp(parseInt(els.slider.value, 10) || 172)
    };

    function match(rows, cm) {
      var last = rows.length - 1;
      if (cm < rows[0].min) return { i: 0, below: true };
      if (cm >= rows[last].max) return { i: last, above: true };
      for (var i = 0; i <= last; i++) {
        if (cm >= rows[i].min && cm < rows[i].max) return { i: i };
      }
      return { i: last };
    }

    function setPressed(btns, attr, value) {
      btns.forEach(function (b) {
        var on = b.getAttribute(attr) === value;
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        b.classList.toggle('is-on', on);
      });
    }

    function render() {
      var cm = state.cm;
      var main = state.unit === 'ft' ? ftin(cm) : cm + ' cm';
      var alt = state.unit === 'ft' ? cm + ' cm' : ftin(cm);

      els.readMain.textContent = main;
      els.readAlt.textContent = alt;
      els.endMin.textContent = state.unit === 'ft' ? ftin(MIN) : MIN + ' cm';
      els.endMax.textContent = state.unit === 'ft' ? ftin(MAX) : MAX + ' cm';
      els.slider.value = cm;
      els.slider.setAttribute('aria-valuetext', main);
      setPressed(typeBtns, 'data-type', state.type);
      setPressed(unitBtns, 'data-unit', state.unit);

      // Highlight the matching row in every chart.
      Object.keys(charts).forEach(function (key) {
        var chart = charts[key];
        var m = match(chart.rows, cm);
        chart.rows.forEach(function (r, i) {
          var on = i === m.i;
          r.el.classList.toggle('is-on', on);
          var badge = r.el.querySelector('.sz-sz');
          var yours = r.el.querySelector('[data-yours]');
          if (badge) badge.classList.toggle('is-on', on);
          if (yours) yours.hidden = !on;
        });
        [].forEach.call(chart.table.querySelectorAll('[data-read]'), function (b) { b.textContent = main; });
      });

      var chart = charts[state.type];
      if (!chart) return;
      var m = match(chart.rows, cm);
      var row = chart.rows[m.i];
      var last = chart.rows.length - 1;
      var lower = state.type;
      var tag = '';
      var text = '';
      if (m.below) {
        tag = 'Below chart';
        text = row.size + ' is the smallest ' + lower + ' size here. Check the manufacturer’s guide for smaller frames.';
      } else if (m.above) {
        tag = 'Above chart';
        text = row.size + ' is the largest ' + lower + ' size here. Check the manufacturer’s guide for bigger frames.';
      } else if (m.i > 0 && cm - row.min < 2) {
        tag = 'Close call';
        text = 'You’re near the line with size ' + chart.rows[m.i - 1].size + '. Check the rider height on the listing.';
      } else if (m.i < last && row.max - cm <= 2) {
        tag = 'Close call';
        text = 'You’re near the line with size ' + chart.rows[m.i + 1].size + '. Check the rider height on the listing.';
      }

      els.resType.textContent = lower;
      els.resSize.textContent = row.size;
      els.resCm.textContent = row.cm;
      els.resFt.textContent = row.ft;
      els.resSpecs.textContent = '';
      [row.frame + ' frame', row.inch].forEach(function (s) {
        if (!s) return;
        var span = document.createElement('span');
        span.className = 'sz-spec';
        span.textContent = s;
        els.resSpecs.appendChild(span);
      });
      els.note.hidden = !text;
      els.noteTag.textContent = tag;
      els.noteText.textContent = text;
      els.ctaSize.textContent = row.size;
      els.ctaType.textContent = lower;
      if (chart.concept) els.cta.setAttribute('href', shopUrl(root.getAttribute('data-search-url') || '/search', chart, row.size));
    }

    function nudge(dir) {
      var next = state.unit === 'ft' ? Math.round((Math.round(state.cm / 2.54) + dir) * 2.54) : state.cm + dir;
      state.cm = clamp(next);
      render();
    }

    typeBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.type = b.getAttribute('data-type'); render(); });
    });
    unitBtns.forEach(function (b) {
      b.addEventListener('click', function () { state.unit = b.getAttribute('data-unit'); render(); });
    });
    [].forEach.call(finder.querySelectorAll('[data-step]'), function (b) {
      b.addEventListener('click', function () { nudge(parseInt(b.getAttribute('data-step'), 10)); });
    });
    els.slider.addEventListener('input', function () {
      state.cm = clamp(parseInt(els.slider.value, 10));
      render();
    });

    render();
  }

  [].forEach.call(document.querySelectorAll('[data-sizing]'), init);
})();
